import { useState } from 'react';
import NextImage from '@/components/NextImage';
import styles from './index.module.scss';
import classNames from 'classnames';
import { useGlobal } from '@/utils/useGlobal';
import EfDialogYoutube from '@elem/ui/ef-dialog-youtube';
import Subtract from './svg/Subtract';
import gtm from '@/utils/gtm';
import { zhCnOrderLink } from '@elem/compPage/Powerocean';
import { EFPowerOceanYearsIconEN } from './svg/EFPowerOceanYearsIconEN';
import EcoDialogVideo from 'eco-design/elements/eco-dialog-video';

export default function FirstKV(props: { className?: string }) {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.FirstKV');

    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const handleVideoPlay = () => {
        setShowEFVideoModal(true);
    };
    const handleJump = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_banner',
            banner_name: t('title'),
            position: 'banner_1',
            button_name: t('btn2'),
        });

        window.open(zhCnOrderLink, '_blank');
    };

    return (
        <div className={classNames(styles.firstKV, props.className)}>
            <div className="bg-img">
                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713518496431/PC-KV-tuya.jpg" alt={t('title')} />
                <div className="years">
                    <EFPowerOceanYearsIconEN />
                </div>
            </div>

            <div className="bg-img-h5">
                <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713518511535/MO-KV-tuya.jpg" alt={t('title')} />

                <div className="years-h5">
                    <EFPowerOceanYearsIconEN />
                </div>
            </div>

            <div className="text-box">
                <div className="title">{t('title')}</div>
                <div className="sub-title">{t('desc')}</div>
                <div className="btn-box">
                    <div className="video-btn" onClick={handleVideoPlay}>
                        {t('btn1')}
                        <Subtract className="video-icon" />
                    </div>
                    <div className="jump-btn" onClick={handleJump}>
                        {t('btn2')}
                    </div>
                </div>
            </div>

            <EcoDialogVideo
                open={showEFVideoModal}
                src={'https://websiteoss.ecoflow.com/upload/video/1767079088203/homebattery-CN.mp4'}
                callback={() => setShowEFVideoModal(false)}
            />
        </div>
    );
}
